<div #sidemenu class="sidemenu">
  <nav class="navbar navbar-vertical bg-white navbar-light align-items-start">
    <div class="d-flex flex-column">
      <div>
        <div class="text-center">
          <div
            class="d-flex flex-row align-items-center cursor-pointer text-danger"
            (click)="toggle()"
          >
            <img
              class="logo-icon"
              src="../assets/img/brand/logo-icon-flat.png"
            />
            <img
              class="logo-text ml-3 collapsed-invisible"
              src="../assets/img/brand/logo-text-azul.png"
            />
            <!--            <i class="fa-solid fa-layer-group fa-2xl"></i>-->
            <!--            <h1 class="m-2 collapsed-invisible">LegalManager<strong>Lite</strong></h1>-->
            <i
              class="fa-solid fa-right-from-bracket fa-rotate-180 ml-4 text-default"
            ></i>
          </div>
        </div>
        <!-- Navigation -->
        <ul class="navbar-nav mt-3">
          <li class="nav-item">
            <a
              routerLinkActive="active"
              [matTooltip]="navigationPages.dashboard.titleKey | translate"
              routerLink="/dashboard"
              (click)="close()"
              class="nav-link"
            >
              <div data-tour-id="menu-dashboard"><i [class]="navigationPages.dashboard.icon + ' fa-xl'"></i></div>
              <h3 class="m-0 ml-3 mt-1 collapsed-invisible">
                {{ navigationPages.dashboard.titleKey | translate }}
              </h3>
            </a>
          </li>

          <li class="nav-item">
            <a
              routerLinkActive="active"
              [matTooltip]="navigationPages.tasks.titleKey | translate"
              routerLink="/tasks"
              (click)="close()"
              class="nav-link"
            >
              <div data-tour-id="menu-tasks"><i [class]="navigationPages.tasks.icon"></i></div>
              <h3 class="m-0 ml-3 mt-1 collapsed-invisible">
                {{ navigationPages.tasks.titleKey | translate }}
              </h3>
            </a>
          </li>

          <li class="nav-item">
            <a
              routerLinkActive="active"
              [matTooltip]="navigationPages.projects.titleKey | translate"
              routerLink="/projects"
              (click)="close()"
              class="nav-link"
            >
              <div data-tour-id="menu-projects"><i [class]="navigationPages.projects.icon"></i></div>
              <h3 class="m-0 ml-3 mt-1 collapsed-invisible">
                {{ navigationPages.projects.titleKey | translate }}
              </h3>
            </a>
          </li>

          <li class="nav-item" *ngIf="controlQueueMenuEnabled">
            <a
              routerLinkActive="active"
              [matTooltip]="navigationPages.controlQueue.titleKey | translate"
              routerLink="/controladoria"
              (click)="close()"
              class="nav-link"
            >
              <div data-tour-id="menu-control-queue" class="control-queue-menu-icon">
                <i [class]="navigationPages.controlQueue.icon"></i>
                <span
                  *ngIf="controlQueuePendingReviewCount > 0"
                  class="control-queue-menu-counter"
                  [matTooltip]="'control_queue.menu.pending_reviews' | translate: { count: controlQueuePendingReviewCount }"
                >
                  {{ controlQueuePendingReviewCountLabel }}
                </span>
              </div>
              <h3 class="m-0 ml-3 mt-1 collapsed-invisible">
                {{ navigationPages.controlQueue.titleKey | translate }}
              </h3>
            </a>
          </li>

          <li class="nav-item" *ngIf="!isLimited">
            <a routerLinkActive="active" [matTooltip]="navigationPages.finance.titleKey | translate" routerLink="/finance" (click)="close()" class="nav-link">
              <div data-tour-id="menu-finance"><i [class]="navigationPages.finance.icon"></i></div>
              <h3 class="m-0 ml-3 mt-1 collapsed-invisible">{{ navigationPages.finance.titleKey | translate }}</h3>
            </a>
          </li>
        </ul>
        <!-- Divider -->
        <hr class="my-3">
        <ul class="navbar-nav">
          <li class="nav-item" *ngIf="documentGeneratorMenuEnabled">
            <a routerLinkActive="active" [matTooltip]="navigationPages.documentGenerator.titleKey | translate" routerLink="/doc-generator" (click)="close()" class="nav-link">
              <div><i [class]="navigationPages.documentGenerator.icon"></i></div>
              <h3 class="m-0 ml-3 collapsed-invisible">{{ navigationPages.documentGenerator.titleKey | translate }}</h3>
            </a>
          </li>
        </ul>
        <hr class="my-3">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a routerLinkActive="active" [matTooltip]="navigationPages.customers.titleKey | translate" routerLink="/customers" (click)="close()" class="nav-link">
              <div data-tour-id="menu-customers"><i [class]="navigationPages.customers.icon"></i></div>
              <h3 class="m-0 ml-3 collapsed-invisible">{{ navigationPages.customers.titleKey | translate }}</h3>
            </a>
          </li>
        </ul>
        <!-- Divider -->
        <hr class="my-3" />
        <!-- Heading -->
        <ul class="navbar-nav">
          <ng-container *ngIf="isAdmin">
            <li class="nav-item" *ngFor="let adminMenuItem of adminMenuItems">
              <a
                routerLinkActive="active"
                [matTooltip]="adminMenuItem.titleKey | translate"
                [routerLink]="adminMenuItem.path"
                (click)="close()"
                class="nav-link"
              >
                <div [attr.data-tour-id]="adminMenuItem.dataTourId"><i [class]="adminMenuItem.icon"></i></div>
                <h3 class="m-0 ml-3 collapsed-invisible">
                  {{ adminMenuItem.titleKey | translate }}
                </h3>
              </a>
            </li>
          </ng-container>
        </ul>
        <hr class="my-3">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              [matTooltip]="'core.menu.support' | translate"
              [href]="manualUrl"
              target="_blank"
              rel="noopener"
              (click)="openManual($event)"
              class="nav-link"
            >
              <div data-tour-id="menu-help"><i class="fa-solid fa-circle-question"></i></div>
              <h3 class="m-0 ml-3 collapsed-invisible">
                {{ "core.menu.support" | translate }}
              </h3>
            </a>
          </li>
          <!--          <li class="nav-item">-->
          <!--            <a class="nav-link" href="https://demos.creative-tim.com/argon-dashboard-angular/documentation/alerts">-->
          <!--              <i class="ni ni-ui-04"></i> Components-->
          <!--            </a>-->
          <!--          </li>-->
        </ul>
      </div>
    </div>
  </nav>

  <nav class="navbar navbar-top navbar-expand-md tenant-div" [ngClass]="this.isCollapsed ? 'tenant-invisible' : ''"  id="navbar-main">
    <ul class="navbar-nav align-items-center d-flex">
      <li class="nav-item">
        <div ngbDropdown placement="top" #tenantDropdown="ngbDropdown">
          <a class="nav-link pr-0" role="button" data-tour-id="tenant-menu" ngbDropdownToggle>
            <div class="media align-items-center">
              <app-avatar size="sm" [entityWithAvatar]="this.userService.loadLoggedUserTenant()?.tenant"></app-avatar>
              <h3 class="m-0 ml-3 collapsed-invisible tenant-name" *ngIf="!this.isCollapsed">
                {{ this.userService.loadLoggedUserTenant()?.tenant?.name }}
              </h3>
            </div>
          </a>

          <div class="dropdown-content dropdown-bottom-arrow dropdown-arrow-left p-3 dropdown-workspace-adjust" ngbDropdownMenu>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Configurações</h6>
          </div>

          <a
            routerLinkActive="active"
            href="javascript:void(0)"
            class="dropdown-item"
            data-tour-id="tenant-switch-workspace"
            (click)="showTenantOptions()"
            *ngIf="this.userTenants && this.userTenants.length > 1"
          >
            <i class="ni ni-single-02"></i>
            <span>{{
                "core.user_menu.switch_workspace" | translate
              }}</span>
          </a>

          <a
            routerLinkActive="active"
            [routerLink]="['/settings']"
            class="dropdown-item"
            data-tour-id="menu-tenant-settings"
          >
            <i [class]="navigationPages.workspaceSettings.icon"></i>
            <span>{{ "core.user_menu.settings" | translate }}</span>
          </a>
        </div>
        </div>
      </li>
    </ul>
  </nav>
</div>
